import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';
import { Patterns } from 'src/app/core/resources/patterns';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { CargoBillingPending } from 'src/app/core/interfaces/cargoBillingPending';
import { NgxSpinnerService } from 'ngx-spinner';
import { Utils } from 'src/app/core/resources/utils';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { TransportCompany } from 'src/app/core/interfaces/transportCompany';
import { FreightListService } from '../cargo-list/cargo-list.service';
import { BasicResponse } from 'src/app/core/interfaces/basicResponse';
import { Dialog } from 'src/app/core/resources/dialog';
import { PreBillService } from 'src/app/core/services/pre-bill.service';
import { PreBill, PreBillState } from 'src/app/core/interfaces/preBill';
import { CargoStateEnum } from 'src/app/core/enums/cargoState.enum';
import { ResponseList } from 'src/app/core/interfaces/response-list';
import { AuthService } from 'src/app/core/services/authentication.service';
import { SettingId } from 'src/app/core/interfaces/saas-config';

@Component({
  selector: 'app-cargo-update',
  templateUrl: './cargo-update.component.html',
  styleUrls: ['./cargo-update.component.scss']
})
export class CargoUpdateComponent implements OnInit {
  public numCargo = new FormControl(null, [Validators.required, Validators.pattern(this.patterns.BILL_FORMAT.source)]);
  public preBillControl = new FormControl(null, [Validators.required]);
  public idsWithBill: Array<number> = [];
  public idsWithoutBill: Array<number> = [];
  public cargos: Cargo[] = [];
  typeBilling: string = 'bill';
  constructor(
    public dialogRef: MatDialogRef<CargoUpdateComponent>,
    private patterns: Patterns,
    private snackBarService: SnackBarService,
    private spinner: NgxSpinnerService,
    public utils: Utils,
    public cargoListService: FreightListService,
    private dialogPrompt: Dialog,
    private preBillService: PreBillService,
    private freightListService: FreightListService,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: {
      title: string,
      idsWithBill?: number[],
      idsWithoutBill?: number[],
      cargos?: Cargo[]
    }) { }

  ngOnInit() {
    if (this.data.idsWithBill) this.idsWithBill = this.data.idsWithBill;
    if (this.data.idsWithoutBill) this.idsWithoutBill = this.data.idsWithoutBill;
    if (this.data.cargos) this.cargos = this.data.cargos;
  }

  public closeDialog() {
    if (this.data.title === "Atar número de factura manualmente") {
      if (this.numCargo.invalid || this.numCargo.value === null) {
        this.snackBarService.openSnackBar("Por favor ingrese un formato de factura válido. Por ej: TCRG-1234", undefined, "alert")
      } else {
        this.pendingBillingCargo();
      }
    } else if (this.data.title === "Facturar por Prefactura") {
      if (this.preBillControl.invalid || this.preBillControl.value === null)
        this.snackBarService.openSnackBar("Por favor ingrese un número de prefactura válido", undefined, "alert");
      else this.billByPreBill();
    } else {
      this.dialogRef.close(this.numCargo.value);
    }
  }

  pendingBillingCargo() {
    this.spinner.show();
    let body: CargoBillingPending = {
      cargos: [],
      billingId: this.numCargo.value
    }
    body.cargos = this.cargos.map((cargo) => {
      return cargo.id;
    });
    this.cargoListService.pendingBillingCargo(body, this.typeBilling)
      .subscribe((success: BasicResponse) => {
        this.spinner.hide();
        if (success.message === 'Update') {
          this.snackBarService.openSnackBar('Se ha enviado la información correctamente');
          this.dialogRef.close({ state: true });
        } else if (success.message) {
          this.spinner.hide();
          this.snackBarService.openSnackBar(success.message, undefined, 'error');
          this.dialogRef.close();
        } else {
          this.spinner.hide();
          this.snackBarService.openSnackBar('Ocurrió un error al realizar la facturación, contacte al Administrador', undefined, 'error');
        }


      },
        error => {
          this.spinner.hide();
          const backendMessage = error && error.error && error.error.message;
          if (error && error.status === 400 && backendMessage) {
            this.dialogPrompt.openDialog({
              title: 'No se puede facturar',
              description: backendMessage,
              iconError: true,
              hideBtnCancel: true
            }).then().catch(err => err);
            return;
          }
          this.snackBarService.openSnackBar('Ocurrió un error al enviar la información', undefined, 'error');
        })
  }

  private async billByPreBill() {
    const preBillConsecutives: number[] = Array.from(new Set(
      this.preBillControl.value.split(',').map(Number).filter(consecutive => !!consecutive)
    ));
    if (!preBillConsecutives.length)
      return this.snackBarService.openSnackBar('Por favor ingrese un número de prefactura válido', undefined, 'alert');
    const availablePreBillList: number[] = [];
    const availableCargoList: Cargo[] = [];
    // Habilitados por prefactura: quien factura los agrupa por empresa de transporte sin partir prefacturas.
    const availableCargosByPreBill: { consecutive: number, cargos: Cargo[], transportCompany?: TransportCompany }[] = [];
    const unavailablePreBillList: { consecutive: number, errorMessage?: string, cargos?: Cargo[] }[] = [];
    const unavailableCargoList: { cargo: Cargo, errorMessage?: string }[] = [];
    const nonExistentPreBillList: number[] = [];
    let companyId: string = null;
    this.spinner.show();
    try {
      for (const preBillConsecutive of preBillConsecutives) {
        const { preBill, availableCargos, unavailableCargos, errorMessage, companyId: preBillCompanyId } = await this.getValidCargosFromPreBill(preBillConsecutive, companyId);
        if (preBillCompanyId) companyId = preBillCompanyId;
        if (!preBill) {
          nonExistentPreBillList.push(preBillConsecutive);
          continue;
        }
        if (!availableCargos || !availableCargos.length) {
          unavailablePreBillList.push({
            consecutive: preBillConsecutive,
            errorMessage,
            cargos: unavailableCargos.map(item => item.cargo)
          });
          unavailableCargoList.push(...unavailableCargos);
          continue;
        }
        availablePreBillList.push(preBillConsecutive);
        availableCargoList.push(...availableCargos);
        availableCargosByPreBill.push({ consecutive: preBillConsecutive, cargos: availableCargos, transportCompany: preBill.transportCompany || null });
        unavailableCargoList.push(...unavailableCargos);
      }
    } finally {
      this.spinner.hide();
    }
    this.dialogRef.close({
      preBillConsecutives,
      availablePreBillList,
      availableCargoList,
      availableCargosByPreBill,
      unavailablePreBillList,
      unavailableCargoList,
      nonExistentPreBillList,
      companyId
    });
  }

  private async getValidCargosFromPreBill(preBillConsecutive: number, companyId: string): Promise<{
    preBill: PreBill,
    availableCargos: Cargo[],
    unavailableCargos: { cargo: Cargo, errorMessage?: string }[],
    errorMessage?: string,
    companyId?: string
  }> {
    try {
      const preBills: ResponseList<PreBill> = await this.preBillService.getPreBills(PreBillState.Created, 1, 1, preBillConsecutive).toPromise();
      if (!preBills || !preBills.results || !preBills.results.length || !preBills.results[0] || !preBills.results[0].consecutive || !preBills.results[0].id)
        return { preBill: null, availableCargos: [], unavailableCargos: [] };
      const preBillFromList = preBills.results[0];
      let preBillDetail: PreBill = null;
      try {
        preBillDetail = await this.preBillService.getPreBill(preBillFromList.id).toPromise();
      } catch (error) {
        preBillDetail = null;
      }
      const cargos = preBillDetail && Array.isArray(preBillDetail.cargos) ? preBillDetail.cargos : [];
      const preBill = preBillDetail || preBillFromList;
      const prebillRequiresValidation = !!(this.authService && this.authService.hasCompanySettingEnabled(SettingId.PREBILL_REQUIRES_VALIDATION));

      if (prebillRequiresValidation && !preBillFromList.validated) {
        return {
          preBill,
          availableCargos: [],
          unavailableCargos: cargos.map(cargo => ({ cargo, errorMessage: `La prefactura ${preBillConsecutive} no está validada` })),
          errorMessage: `La prefactura ${preBillConsecutive} no está validada`
        };
      }
      if (companyId && preBill.companyId !== companyId) {
        return {
          preBill,
          availableCargos: [],
          unavailableCargos: cargos.map(cargo => ({ cargo, errorMessage: `La prefactura ${preBillConsecutive} no coincide con la compañía de las demás prefacturas` })),
          errorMessage: `La prefactura ${preBillConsecutive} no coincide con la compañía de las demás prefacturas`
        };
      }
      if (!preBillDetail)
        return { preBill: preBillFromList, availableCargos: [], unavailableCargos: [], errorMessage: `La prefactura ${preBillConsecutive} no tiene servicios asociados` };

      const availableCargos: Cargo[] = [];
      const unavailableCargos: { cargo: Cargo, errorMessage?: string }[] = [];
      cargos.forEach(cargo => {
        const validation = this.freightListService.isCargoToBill(cargo, 'charges', 'cashed=false', true);
        if (validation.isSelectable && validation.isEnabled) availableCargos.push(cargo);
        else unavailableCargos.push({ cargo, errorMessage: validation.errorMessage || `Servicio inhabilitado` });
      });

      if (!availableCargos.length) {
        return {
          preBill,
          availableCargos: [],
          unavailableCargos,
          errorMessage: `No se encontró ningún servicio válido para facturar en la prefactura ${preBillConsecutive}`
        };
      }

      return { preBill, availableCargos, unavailableCargos, companyId: preBill.companyId };
    } catch (error) {
      return { preBill: null, availableCargos: [], unavailableCargos: [] };
    }
  }
}
